<template>
  <div>
    <b-row align-v="center" class="loader" v-if="is_saving">
        <b-col>
            <b-spinner></b-spinner>
            <br><br>
            <strong>Loading</strong>
        </b-col>
    </b-row>
    <b-alert show variant="danger"  v-for="(error_message, index) in error_messages">{{error_message}}</b-alert>
    <b-row class="bg-white m-0 border">
      <b-col class=" p-3">
        <b-form @submit.prevent="save">

          <b-row class="m-0 mb-3">
            <b-col cols="1" class="text-center p-2 bg-info text-white d-flex align-items-center justify-content-center">
              <font-awesome-icon icon="user" class="h2 mb-0" />
            </b-col>
            <b-col class="p-2 bg-white d-flex align-items-center border">
              <div>
                <h6 class="mb-0 text-muted">Employee</h6>
                <h2 class="mb-0">
                  <a href="#" @click.prevent="manpower_modal=true">
                    <strong v-if="form.manpower_id=='-1'">....</strong>
                    <template v-else><strong>{{form.manpower.full_name}}</strong> <b-badge variant="info">{{form.manpower.employee_id}}</b-badge></template>
                  </a>
                </h2>
              </div>
            </b-col>
          </b-row>
          <template  v-if="form.manpower_id!='-1'">
          <table class="table border-bottom">
            <thead class="thead-dark">
            <tr>
              <th scope="col">Description</th>
              <th scope="col">Available balance</th>
            </tr>
            </thead>
            <tbody>
            <template v-for="(leave_benefit, index) in leave_benefits">
              <tr>
                <th scope="row">{{leave_benefit.description}}</th>
                <th scope="row"><number-format-component :input_value="Number(leave_benefit.balance)" :currency="false"/></th>
              </tr>
            </template>
            </tbody>
          </table>
          <fieldset class="border p-3 my-3">
            <legend  class="w-auto bg-facebook px-2 py-1 text-white rounded border h6">Leave Application</legend>
            <table class="table table-bordered mt-2 mb-0 table-sm">
              <thead class="thead-dark">
              <tr>
                <th scope="col">Leave Description</th>
                <th scope="col" class="text-center">Qty</th>
                <th scope="col" class="text-center">Date</th>
                <th scope="col" class="text-center">Remarks</th>
              </tr>
              </thead>
              <tbody class="bg-white text-dark">
              <tr v-for="(leave_application, index) in leave_applications">
                <td>
                  <strong>{{leave_application.description}}</strong>
                </td>
                <td class="text-center">
                  <b-form-input
                          v-model="leave_application.qty"
                          type="number"
                          step="any"
                          min="0"
                          max="1"
                          size="small"
                  ></b-form-input>
                </td>
                <td class="text-center">
                  <b-form-input
                          v-model="leave_application.date"
                          type="date"
                          :required="(leave_application.qty>0)"
                          size="small"
                  ></b-form-input>
                </td>
                <td class="text-center">
                  <b-form-input
                          v-model="leave_application.remarks"
                          type="text"
                          size="small"
                          :required="(leave_application.qty>0)"
                  ></b-form-input>
                </td>
              </tr>
              </tbody>
            </table>
          </fieldset>
          </template>
          <div class="text-right">
            <router-link to="/manpowers/preference-categories/all">
              <b-button v-if="form.id!=-1" variant="dark" size="sm" class="mr-1">
                <font-awesome-icon icon="chevron-left" /> Back</b-button>
            </router-link>
              <b-button type="submit" variant="dark" size="sm"><font-awesome-icon icon="save" /> Submit Leave Application</b-button>
          </div>
        </b-form>
      </b-col>
    </b-row>
    <!-- START OF TOOL MODAL -->
      <b-modal v-model="manpower_modal" centered size="md" body-class="p-0" :hide-footer="true" :hide-header="true">
              <manpower-modal @select="selectManpower" />
      </b-modal>
      <!-- END OF TOOL MODAL -->
  </div>
</template>
<script>
    import ManpowerModal from '@/views/helpers/ManpowerModal.vue';
    import NumberFormatComponent from '@/views/helpers/NumberFormatComponent.vue';
    import SwalMixin from '@/views/mixins/Swal.js'
    export default {
      mixins:[SwalMixin],
      components: {ManpowerModal,NumberFormatComponent},
      data() {
        return {
          form: {
            id:-1,
            manpower_id: -1,
            manpower:{},
          },
          form_copy:{},
          is_saving:false,
          manpower_modal:false,
          leave_benefits:[],
          leave_applications:[],
          error_messages:[]
        }
      },
      watch: {
        form:{
            immediate: true,
            deep:true,
            handler(){
              
            }
        }
      },
      created(){
        this.form_copy=JSON.parse(JSON.stringify(this.form));
        if(typeof this.$route.params.id !== 'undefined')
        this.get();
      },
      methods: {
        get(){
          this.is_saving=true;
          this.axios.get('maintenance/preference_categories/get',{params:{id:this.$route.params.id}}).then(response => {
              this.form.preferences = [];
              this.form.id=response.data.id;
              this.form.description=response.data.description;
              response.data.preferences.forEach((e) => {
                let preference = e;
                preference.is_deleted=false;
                preference.show_details=false;
                this.form.preferences.push(preference);
              });
              this.is_saving=false;
          }).catch(error => console.log(error));
        },
        save(){
          event.preventDefault()
          this.swalConfirmSubmit((data)=>{
              if (data.value) {
                this.is_saving=true;
                let form = {
                  'leave_applications':this.leave_applications
                }
                this.axios.post('leave-applications/save',form).then(response => {
                    this.swalTransactionCompleted();
                    this.is_saving=false;
                    this.error_messages = [];
                    this.leave_applications = [];
                    this.leave_benefits = [];
                    this.form=JSON.parse(JSON.stringify(this.form_copy));
                }).catch(error => {
                    this.swal_transaction_error_data.text = 'Unable to process leave application';
                    this.swalRequestError();
                    this.error_messages = error.response.data;
                    this.is_saving=false;
                });
              }
          });
        },
        selectManpower(manpower){
          this.form.manpower = manpower;
          this.form.manpower_id = manpower.id;
          this.manpower_modal=false;
          this.fetchLeaveCredits();
        },
        fetchLeaveCredits(){
          this.is_saving=true;
          this.axios.get('maintenance/leave-benefits/fetch-available-leave-credits',{params:{manpower_id:this.form.manpower_id}}).then(response => {
            response.data.forEach((e) => {
              this.leave_benefits = response.data;
              for (let i = 0; i < Number(e.balance); i++) {
                let credit = {
                  date:'',
                  leave_benefit_id:e.leave_benefit_id,
                  manpower_id:this.form.manpower_id,
                  qty:0,
                  description:e.description,
                  remarks:''
                };

                this.leave_applications.push(credit);
              }
            });

            this.is_saving=false;
          }).catch(error => console.log(error));
        }
      }
    }
</script>
